import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 信用评价服务-结果业务单服务
 */
export class CreditEvaResultController {
    constructor() {
        this.baseurl = 'creditEvaResultController.assx/';
    }

    /**
     * 
     * openId:String, token:String, id:String
     */
    getResultDocDTOById(openId, token, id){
        return request.post(this.baseurl + 'getResultDocDTOById', Qs.stringify({ openId:openId, token:token, id:id }));
    }

    /**
     * 
     * openId:String, token:String, ywdbh:String
     */
    getResultDocDTOByApplyYwdbh(openId, token, ywdbh){
        return request.post(this.baseurl + 'getResultDocDTOByApplyYwdbh', Qs.stringify({ openId:openId, token:token, ywdbh:ywdbh }));
    }

    /**
     * 
     * ywdbh:String
     */
    getResultDocDTOByApplyYwdbh_builtBureauWebsite(ywdbh){
        return request.post(this.baseurl + 'getResultDocDTOByApplyYwdbh_builtBureauWebsite', Qs.stringify({ ywdbh:ywdbh }));
    }

    /**
     * 
     * openId:String, token:String, id:String, ywdbh:String, creditBodyName:String, createDate_l:String, createDate_r:String, isQueryAll:boolean, startIndex:int, maxSize:int
     */
    getResultDocDTOList(openId, token, id, ywdbh, creditBodyName, createDate_l, createDate_r, isQueryAll, startIndex, maxSize){
        return request.post(this.baseurl + 'getResultDocDTOList', Qs.stringify({ openId:openId, token:token, id:id, ywdbh:ywdbh, creditBodyName:creditBodyName, createDate_l:createDate_l, createDate_r:createDate_r, isQueryAll:isQueryAll, startIndex:startIndex, maxSize:maxSize }));
    }
}